import React, { useState, useEffect } from "react";
import Slider from "react-slick";

import {
  Modal,
  ModalBody,
} from "reactstrap";


const ImageDetailModal = (props) => {
  const { items } = props;
  const [imgIndex, setImgIndex] =  useState(props.imgIndex || 0)
  const [showingTrans, setShowingTrans] = useState(false);

  const handleNext = (e) => {
    e.preventDefault();
    setImgIndex(imgIndex < items.length - 1 ? imgIndex + 1 : imgIndex);
  }
  const handlePrev = (e) => {
    e.preventDefault();
    setImgIndex(imgIndex > 0 ? imgIndex - 1 : 0);
  }

  const watchKeypress = (e) => {
    const keyName = e.key;
    console.log('watchKeypress', keyName, e, imgIndex, items);
    if(keyName === 'ArrowLeft' || keyName == 'ArrowUp') {
    e.preventDefault();
      setImgIndex(imgIndex > 0 ? imgIndex - 1 : 0);
    } else if(keyName === 'ArrowRight' || keyName == 'ArrowDown') {
      e.preventDefault();
      console.log('imgIndex', imgIndex < items.length - 1 ? (imgIndex + 1) : imgIndex);
      setImgIndex(imgIndex < items.length - 1 ? (imgIndex + 1) : imgIndex);
    } else if(keyName === 'Escape') {
      e.preventDefault();
      setImgIndex(null);
      props.onCancel(e);
    }
  }
  useEffect(() => {
    if(document.querySelector('.skiptranslate')) {
      setShowingTrans(true);
    }    
    setImgIndex(props.imgIndex);

  }, [props.imgIndex]);
  const currentImage = items[imgIndex];


  return (
    <Modal
      className={`gallery-image-details ${showingTrans ? 'has-gtranslate' : ''}`}
      fullscreen
      isOpen={props.isOpen}
    >    
      <ModalBody tabIndex={0}  onKeyDown={watchKeypress} autoFocus={true}>
        <a className="button-close-modal" onClick={e => props.onCancel(e, 2)}>
          Close
        </a>
        <button className="button-back-photos" onClick={e => props.onCancel(e)}>
          <i className="fa fa-arrow-left"/>
            &nbsp;
            Back to photos 
        </button>
        <button type="button" data-role="none" className="gallery-button gallery-nav-prev" onClick={handlePrev} disabled={imgIndex === 0}> Prev</button>
        <div  className="gallery-image-carousel" >
          <div className="gallery-image-wrapper">
            <img src={currentImage?.image_url}/>
          </div>
        </div>
        <button type="button" data-role="none" className="gallery-button gallery-nav-next" onClick={handleNext} disabled={imgIndex === items.length - 1}> Next</button>
      </ModalBody>
     
    </Modal>
  );
};

export default ImageDetailModal;
